import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { prerenderedLoadable } from 'utils/prefetch';
const FAQPage = prerenderedLoadable(() => import(/* webpackChunkName: "FAQ" */ 'containers/Content/FAQ/FAQ'));
export const FAQ = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(FAQPage, null)));
